import React from 'react';
import { ISvgDisplayProps } from '../interface/svgEditor';

const SvgDisplay: React.FC<ISvgDisplayProps> = ({ svgContainerRef, className = '' }) => {
    return (
        <div className={`svg-editor-top-panel ${className}`}>
            <h1 className="svg-editor-title">展示区域，支持下载（证书包-SVG、PNG、JPEG、PDF）</h1>
            <div className="svg-editor-svg-container">
                <div ref={svgContainerRef} />
            </div>
        </div>
    );
};

export default SvgDisplay;
